import { createContext, useContext } from "react";
import { useTranslation } from "react-i18next";

export type BidSubject = "supplier" | "entry" | "participant";

const BidSubjectContext = createContext<BidSubject>("supplier");

export const BidSubjectProvider = BidSubjectContext.Provider;

export const useBidSubjectTerms = (subjectOverride?: BidSubject) => {
  const { t } = useTranslation();
  const subjectInContext = useContext(BidSubjectContext);
  switch (subjectOverride ?? subjectInContext) {
    case "entry":
      return {
        subject: t("Entry"),
        subjects: t("Entries"),
        answer: t("Participant's answer"),
        notAnswered: t("Not answered by the participant"),
        noEspd: t("The participant has not submitted an ESPD response for this entry."),
        previous: t("Previous entry"),
        next: t("Next entry"),
      };
    case "participant":
      return {
        subject: t("Participant"),
        subjects: t("Participants"),
        answer: t("Participant's answer"),
        notAnswered: t("Not answered by the participant"),
        noEspd: t("The participant has not submitted an ESPD response for this entry."),
        previous: t("Previous participant"),
        next: t("Next participant"),
      };
    case "supplier":
      return {
        subject: t("Supplier"),
        subjects: t("Suppliers"),
        answer: t("Supplier's answer"),
        notAnswered: t("Not answered by supplier"),
        noEspd: t("The supplier has not submitted an ESPD response for this bid."),
        previous: t("Previous supplier"),
        next: t("Next supplier"),
      };
  }
};
